import { store } from "../store";
import { clearUser, setUser } from "../ducks/user";
import {
  setCountryInfo,
  setCountryLoading,
  clearCountryInfo,
  CountryInfoPayload,
} from "../ducks/countryInfo";
import {
  setSelectedCountry,
  setSelectedCountryLoading,
  clearSelectedCountry,
  SelectedCountry,
} from "../ducks/selectedCountry";
import { CommonResponse } from "types/types";

export const dispatchSetUser = (user: CommonResponse["data"]) => {
  store.dispatch(setUser(user));
};

export const dispatchClearUser = () => {
  store.dispatch(clearUser());
};

export const dispatchSetCountryInfo = (countryInfo: CountryInfoPayload) => {
  store.dispatch(setCountryInfo(countryInfo));
};

export const dispatchSetCountryLoading = (isLoading: boolean) => {
  store.dispatch(setCountryLoading(isLoading));
};

export const dispatchClearCountryInfo = () => {
  store.dispatch(clearCountryInfo());
};

export const dispatchSetSelectedCountry = (country: SelectedCountry) => {
  store.dispatch(setSelectedCountry(country));
};

export const dispatchSetSelectedCountryLoading = (isLoading: boolean) => {
  store.dispatch(setSelectedCountryLoading(isLoading));
};

export const dispatchClearSelectedCountry = () => {
  store.dispatch(clearSelectedCountry());
};
